/**
 * Copyright 2025 SweetCode. All rights reserved.
 *
 * Process lazy loaded PMW scripts
 */

const lazySelector = "script[type=\"text/pmw-lazy\"]"

// Only a script with a src can be deferred: activation re-injects e.src, and
// nothing else, so a marked inline block would be dropped on the floor.
function getLazyScripts() {
	return Array.from(document.querySelectorAll(lazySelector)).filter((script) => script.src)
}

/**
 * Run the marked inline blocks right away.
 *
 * Up to 1.69.0 the tag filter marked the library's configuration block
 * (pmw.root, pmw.ajax_url, the nonces) together with the library itself, and a
 * marked inline block never executes. Every REST call then went to `undefined`
 * plus the route and 404ed, which cost all server-side event copies. The filter
 * no longer marks inline blocks, but pages served from a cache written by an
 * earlier version still carry the old markup, so run them here.
 *
 * The configuration is plain data. It is safe to run before the library and
 * safe to run twice.
 */
document.querySelectorAll(lazySelector).forEach((script) => {

	if (script.src) return

	script.remove()
	let inlineScript       = document.createElement("script")
	inlineScript.textContent = script.textContent
	document.head.appendChild(inlineScript)
})

// Preload the scripts
getLazyScripts().forEach((script) => {
	let preloadLink  = document.createElement("link")
	preloadLink.href = script.src
	preloadLink.rel  = "preload"
	preloadLink.as   = "script"
	document.head.appendChild(preloadLink)
})

// All user interaction events to listen to
const eventsToListenTo = [
	"keydown",
	"mousedown",
	"mousemove",
	"touchmove",
	"touchstart",
	"touchend",
	"wheel",
	"scroll",
]

// Load scripts after interaction
function activateLazyLoadedScripts() {

	getLazyScripts().forEach((script) => {

		script.remove()
		let preloadedScript = document.createElement("script")
		preloadedScript.src = script.src
		document.body.appendChild(preloadedScript)
	})
}

// Add event listeners to any interaction events
eventsToListenTo.forEach((event) => {
	document.addEventListener(event, function handler() {

		// console log timestamp
		// console.log("timestamp: " + Date.now())

		activateLazyLoadedScripts()

		// detach event listener
		document.removeEventListener(event, handler)

		// detach all event listeners
		// eventsToListenTo.forEach(function (event) {
		// 	document.removeEventListener(event, handler)
		// })
	})
})

// Always fully load scripts on cart and checkout pages
document.addEventListener("DOMContentLoaded", () => {

	if (typeof pmwDataLayer === "undefined") {

		// At this point the pmwDataLayer should be defined
		// It might not be the case if a third-party plugin blocks it, such as a consent management platform or a JavaScript optimizer.
		// console.error("Pixel Manager error: The pmwDataLayer is undefined. Whitelist the pmwDataLayer from any consent management platforms and JavaScript optimizers.")
		return
	}

	if (
		pmwDataLayer?.shop?.page_type === "cart"
		|| pmwDataLayer?.shop?.page_type === "checkout"
		|| pmwDataLayer?.shop?.page_type === "order_received_page"
	) {
		activateLazyLoadedScripts()
	}
}, true)
